import * as React from "react";
import { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Box, Dialog } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { loginApi } from "../../services/authApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SetReferralCode(props) {
  const { disableButton, handleSetReferralCodeSubmit } = props;

  const [registerCode, setRegisterCode] = useState("");

  const handleClickSubmit = (e) => {
    handleSetReferralCodeSubmit({ registerCode });
  };
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography
        component="h1"
        color="darkgoldenrod"
        variant="body1"
        sx={{ textAlign: "center" }}
      >
        در صورت داشتن کد معرف لطفا کد را وارد نمایید
      </Typography>

      <Box noValidate sx={{ mt: 1 }}>
        <TextField
          //   margin="normal"
          sx={{ m: 0.3 }}
          required
          fullWidth
          id="registerCode"
          label="کد معرف"
          name="registerCode"
          value={registerCode}
          onChange={(e) => setRegisterCode(e.target.value)}
          autoComplete="registerCode"
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ذخیره
        </Button>
        {/* <Grid container>
              <Container maxWidth="sx"  >
                <Link href="#"  onClick={() => { handleShowingFormsValues("11")}} variant="body2">
                {"قبلا ثبت نام کرده ام!"}
                </Link>
              </Container >
              <Container  maxWidth="sx" >
          <Link href="#" onClick={() => { handleShowingFormsValues("111") }} variant="body2">
            {"تغییر شماره ثبت نام"}
          </Link>
              </Container >
            </Grid> */}
      </Box>
    </Box>
  );
}
